














import { Component, Prop, Vue } from "@zoovu/runner-browser-api";
import { RadioButtonAnswerView } from "@zoovu/runner-web-design-base";

@Component({
  name: "RadioButtonAnswerView",
  mixins: [RadioButtonAnswerView]
})
export default class RadioButtonAnswerViewExtended extends Vue {
  @Prop()
  hasQuestionCustomWidthAttribute!: boolean;
}
